const services = {
  name: "services",
  title: "محصولات",
  children: {
    right: [
      {
        name: "vpc",
        title: "دیتاسنتر ابری",
        route: "/vpc",
        description: "تمام امکانات یک دیتاسنتر فیزیکی در اختیار شما",
        icon: "vpc.svg",
      },
      {
        name: "vps",
        title: "سرور ابری",
        route: "/vps",
        description: "سرور ابری اختصاصی خود را انتخاب کنید",
        icon: "vps.svg",
      },
      {
        name: "cdn",
        title: "شبکه توزیع محتوا ( CDN )",
        route: "/cdn",
        description: "از هرکجا، به سرعت در دسترس باشید",
        icon: "cdn.svg",
      },
      {
        name: "paas",
        title: "پلتفرم ابری",
        route: "/paas",
        description: "کانتینرها در خدمت شما برای تمرکز بیشتر",
        icon: "paas.svg",
      },
      {
        name: "cloudSecurity",
        title: "امنیت ابری",
        route: "/cloud-security",
        description: "تامین امنیت سرویس‌های ابری با قدرت و سرعت بالا",
        icon: "security.svg",
      },
      {
        name: "manageServices",
        title: "سرویس مدیریت شده",
        route: "/manageservices",
        description: "متخصصین آبالون را همراه خود داشته باشید",
        icon: "manage.svg",
      },
      {
        name: "object-storage",
        title: "آبجکت استوریج",
        route: "/object-storage",
        description: "ذخیره‌سازی پایدار و بدون محدودیت",
        tag: "BETA",
        icon: "storage.svg",
      },
    ],
    items: [
      {
        name: "infrastructure",
        title: "زیرساخت ابری",
        icon: "infra.svg",
        children: [
          {
            name: "datacenter",
            title: "دیتاسنتر ابری",
            route: "/vpc",
          },
          {
            name: "server",
            title: "سرور ابری",
            route: "/vps",
          },
          {
            name: "private cloud",
            title: "ابر خصوصی",
            route: "/privatecloud",
          },
        ],
      },
      {
        name: "cdn",
        title: "شبکه توزیع محتوا",
        icon: "cdn.svg",
        soon: true,
        children: [
          {
            name: "cdn",
            title: "شبکه توزیع محتوا (CDN)",
            route: "/cdn",
          },
          {
            name: "ddos",
            title: "محافظت DDoS",
            route: "/ddos-protection",
          },
          {
            name: "firewall",
            title: "فایروال ابری",
            route: "/cloud-security/#firewall",
          },
          {
            name: "waf",
            title: "فایروال وب (WAF)",
            route: "/waf",
          },
          {
            name: "dns",
            title: "DNS ابری",
            route: "/dns",
          },
        ],
      },
      {
        name: "manage-service",
        title: "سرویس‌های مدیریت شده",
        icon: "manage24.svg",
        children: [
          {
            name: "organization-services",
            title: "سرویس‌های سازمانی",
            route: "/manageservices",
          },
          {
            name: "infrastructure-tools",
            title: "ابزارهای زیرساختی",
            route: "/devops",
          },
          {
            name: "devops",
            title: "راهکارهای دواپس",
            route: "/devops",
          },
        ],
      },
      {
        name: "cloud-network",
        title: "شبکه ابری",
        soon: true,
        icon: "cloud-network.svg",
        children: [
          {
            name: "Load Balancing",
            title: "توزیع بار",
            description: "(Load Balancing)",
            route: "/loadbalancer",
            soon: false,
          },
        ],
      },
    ],
  },
};

const solutions = {
  name: "solutions",
  title: "راهکار‌ها",
  children: {
    right: [
      {
        name: "migrate",
        title: "مهاجرت ابری",
        route: "/migrate",
        description: "زیرساخت سنتی خود را به ابرها ببرید",
        icon: "migrate.svg",
      },
      {
        name: "private-cloud",
        title: "ابر اختصاصی",
        tag: "Private Cloud",
        route: "/privatecloud",
        description: "ابری مخصوص سازمان خود داشته باشید",
        icon: "private-cloud.svg",
      },

      {
        name: "combination-cloud",
        title: "ابر ترکیبی",
        tag: "Hybrid Cloud",
        route: "/privatecloud",
        description: "ابر اختصاصی و ابر عمومی را همزمان تجربه کنید",
        icon: "combination-cloud.svg",
      },
      {
        name: "manageServices",
        title: "سرویس مدیریت شده",
        route: "/manageservices",
        description: "متخصصین آبالون را همراه خود داشته باشید",
        icon: "manage.svg",
      },
    ],
    items: [
      {
        name: "special-solutions",
        title: "راهکار‌های ویژه",
        col: 5,
        classes: "",
        icon: "special.svg",
        children: [
          {
            name: "private-cloud",
            title: "ابر خصوصی",
            route: "/privatecloud",
          },
          {
            name: "organization-cloud-over-noronta",
            title: "ابر ایزوله بر بستر شبکه نورونتا",
            route: "/isolated-cloud",
            soon: false,
          },
          {
            name: "enterprise-solutions",
            title: "راهکارهای سازمانی",
            route: "/enterprise-solutions",
            soon: false,
          },
          {
            name: "devops-service",
            title: "DevOps as a Service",
            route: "/devops",
            soon: false,
          },
          {
            name: "backup-solutions",
            title: "راهکارهای بکاپ OnSite و OffSite",
            route: "/backup-solutions",
            soon: false,
          },
          {
            name: "disaster-recovery",
            title: "راهکار Disaster Recovery",
            route: "/disaster-recovery",
            soon: false,
          },
          {
            name: "soc-service",
            title: "مرکز عملیات امنیت (SOC)",
            route: "/soc",
            soon: false,
          },
          {
            name: "secure-workspace",
            title: "فضای کاری امن",
            route: "/secure-workspace",
            soon: false,
          },
          {
            name: "SIEM",
            title: "SIEM",
            route: "/siem",
            soon: false,
          },
          {
            name: "kubernetes",
            title: "کوبرنتیز سازمانی",
            route: "/kubernetes",
            soon: false,
          },
        ],
      },
    ],
  },
};

const organizationServices = {
  name: "organization-solutions",
  title: "راهکارهای سازمانی",
  children: {
    items: [
      {
        name: "organization-cloud",
        title: "ابر سازمانی",
        icon: "organization.svg",
        children: [
          {
            name: "public-organization-cloud",
            title: "ابر عمومی سازمانی",
            route: "/vpc",
            // icon: "vpc.svg"
          },
          {
            name: "private-organization-cloud",
            title: "ابر اختصاصی سازمانی",
            route: "/privatecloud",
          },
          {
            name: "combination-organization-cloud",
            title: "ابر ترکیبی سازمانی",
            route: "/privatecloud",
          },
          {
            name: "container-organization",
            title: "کانتینر و کوبرنتیز سازمانی",
            route: "/paas",
          },
          {
            name: "cdn-organization-network",
            title: "شبکه توزیع محتوای سازمانی",
            route: "/cdn/#cdn-for-enterprises",
          },
        ],
      },
      {
        name: "organization-profissional-services",
        title: "خدمات تخصصی سازمانی",
        icon: "tech-services-for-organs.svg",
        children: [
          {
            name: "devops",
            title: "خدمات DevOps سازمانی",
            route: "/devops",
          },
          {
            name: "organization-infrastructure-monitoring",
            title: "راهکارهای سازمانی",
            route: "/enterprise-solutions",
          },
          {
            name: "organization-remoteworking-package",
            title: "خدمات سازمانی",
            route: "/enterprise-services",
          },
          {
            name: "dedicated-server",
            title: "سرور اختصاصی",
            route: "/dedicated-server",
          },
          {
            name: "colocation",
            title: "کولوکیشن",
            route: "/colocation",
          },
          {
            name: "backup-solutions",
            title: "راهکارهای بکاپ OnSite و OffSite",
            route: "/backup-solutions",
          },
          {
            name: "disaster-recovery",
            title: "راهکار Disaster Recovery",
            route: "/disaster-recovery",
          },
          {
            name: "object-storage",
            title: "آبجکت استوریج",
            route: "/object-storage",
            soon: false,
          },
          {
            name: "kubernetes",
            title: "کوبرنتیز سازمانی",
            route: "/kubernetes",
            soon: false,
          },
        ],
      },
      {
        name: "comprehensive-organizational-solutions",
        title: "راهکارهای جامع سازمانی",
        icon: "organ-solutions.svg",
        col: 4,
        children: [
          {
            name: "secure-cloud",
            title: "ابر ایزوله",
            description: "ابر اختصاصی بر بستر شبکه سازمانی نورونتا",
            route: "/isolated-cloud",
            popup: false,
          },
          {
            name: "secure-workspace",
            title: "فضای کاری امن",
            route: "/secure-workspace",
            soon: false,
          },
        ],
      },
      {
        name: "organization-documentation",
        title: "مستندات سازمانی",
        icon: "organ-docs.svg",
        children: [
          {
            name: "sla",
            title: "سطوح خدمات (SLA)",
            route: "https://abalon.cloud/blog/sla",
          },
          {
            name: "catalog",
            title: "دانلود کاتالوگ",
            route: "https://abalon.cloud/media/catalogs",
          },
          {
            name: "request-pre-factor",
            title: "درخواست صدور پیش فاکتور",
            route: "",
            popup: true,
          },
          {
            name: "request-organization-proposal",
            title: "درخواست پروپوزال سازمانی",
            route: "",
            popup: true,
          },
        ],
      },
      {
        name: "organization-security",
        title: "امنیت سازمانی",
        icon: "organ-security.svg",
        col: 2,
        children: [
          {
            name: "ddos",
            title: "محافظت DDoS",
            route: "/ddos-protection",
          },
          {
            name: "waf",
            title: "WAF",
            route: "/waf",
          },
          {
            name: "pam",
            title: "PAM ابری",
            route: "/pam",
          },
          {
            name: "soc-service",
            title: "مرکز عملیات امنیت (SOC)",
            route: "/soc",
          },
          {
            name: "SIEM",
            title: "SIEM",
            route: "/siem",
            soon: false,
          },
        ],
      },
      {
        name: "digital-evolution",
        title: "تحول دیجیتال",
        icon: "digital-tahavol.svg",
        children: [
          {
            name: "cloud-migration",
            title: "مهاجرت ابری",
            route: "/migrate",
          },
          {
            name: "professional-counseling",
            title: "مشاوره تخصصی",
            route: "",
            popup: true,
          },
        ],
      },
    ],
  },
};

const cloudStation = {
  name: "cloud-station",
  title: "ایستگاه ابری",
  col: 4,
  children: {
    right: [
      {
        name: "services-guide",
        title: "راهنمای محصولات",
        route: "https://docs.abalon.cloud",
        description: "محصولات آبالون را بیشتر بشناسید",
        icon: "service-help.svg",
      },
      {
        name: "weblog",
        title: "وبلاگ آبالون",
        route: "https://abalon.cloud/blog",
        description: "از ابرها بخوانید",
        icon: "blog.svg",
      },
      {
        name: "faq",
        title: "سوالات متداول",
        route: "https://panel.abalon.cloud/faq",
        description: "نقاط ابهام خود را سریع‌تر برطرف کنید",
        icon: "faq.svg",
      },
    ],
    items: [
      {
        name: "notitle1",
        title: "در دنیای ابرها کنجکاوی کنید",
        classes: "",
        icon: "left7.svg",
        children: [
          {
            name: "weblog",
            title: "وبلاگ",
            route: "https://abalon.cloud/blog",
          },
        ],
      },
      {
        name: "notitle2",
        title: "از متخصصین آبالون بپرسید",
        classes: "",
        icon: "left15.svg",
        children: [
          {
            name: "profissional-conselling",
            title: "مشاوره تخصصی",
            route: "",
            popup: true,
          },
          {
            name: "connect-to-sells",
            title: "ارتباط با واحد فروش",
            route: "",
            popup: true,
          },
          {
            name: "manage-service",
            title: "سرویس‌های مدیریت شده",
            route: "/devops",
          },
          {
            name: "devops-as-a-service",
            title: "دواپس به عنوان سرویس",
            route: "/devops",
          },
          {
            name: "enterprise-solutions",
            title: "راهکارهای سازمانی",
            route: "/enterprise-solutions",
          },
          {
            name: "enterprise-services",
            title: "خدمات سازمانی",
            route: "/enterprise-services",
          },
        ],
      },
      {
        name: "notitle3",
        title: "در آبالون",
        classes: "",
        icon: "in-xaas.svg",
        children: [
          {
            name: "services-guide",
            title: "راهنمای محصولات",
            route: "https://docs.abalon.cloud",
          },
          {
            name: "faq",
            title: "سوالات متداول",
            route: "https://panel.abalon.cloud/faq",
          },
          {
            name: "sla",
            title: "سطوح خدمات (SLA)",
            route: "https://abalon.cloud/blog/sla",
          },
          {
            name: "contact-us",
            title: "تماس با آبالون",
            route: "/contactus",
          },
          {
            name: "about-us",
            title: "درباره آبالون",
            route: "/aboutus",
          },
        ],
      },
    ],
  },
};

const prices = {
  name: "prices",
  title: "قیمت‌گذاری",
  children: {
    right: [
      {
        name: "how-to-price",
        title: "شیوه قیمت‌گذاری",
        route: "https://abalon.cloud/blog/sla",
        description: "هر آنچه درمورد نحوه قیمت‌گذاری باید بدانید",
        icon: "main3.svg",
      },

      {
        name: "sla",
        title: "سطوح خدماتی (SLA)",
        route: "https://abalon.cloud/blog/sla",
        description: "از تعهدات آبالون نسبت به سرویس خود مطلع شوید",
        icon: "sla.svg",
      },
    ],
    items: [
      {
        name: "prices",
        title: "قیمت‌گذاری سرویس‌ها",
        col: 4,
        icon: "prices.svg",
        children: [
          {
            name: "datacenter",
            title: "دیتاسنتر ابری",
            description:
              "قیمت دیتاسنترهای ابری بر اساس منابع پردازشی مورد نیاز",
            route: "/vpc",
            class: "mt-2",
          },
          {
            name: "vps",
            title: "سرور ابری",
            description: "جزئیات قیمت‌گذاری سرورهای ابری",
            route: "/vps",
            class: "mt-2",
          },

          {
            name: "cdn",
            title: "شبکه توزیع محتوا (CDN)",
            description:
              "شیوه قیمت‌گذاری شبکه توزیع محتوا بر اساس فاکتورهای کلیدی",
            route: "/cdn",
            class: "mt-2",
          },
        ],
      },
      {
        name: "prices",
        title: "prices",
        styles: "visibility: hidden",
        children: [
          {
            name: "private-cloud",
            title: "ابر اختصاصی",
            description: "شیوه قیمت‌گذاری پیاده‌سازی ابر اختصاصی",
            route: "/privatecloud",
            class: "mt-2",
          },
          {
            name: "combination-cloud",
            title: "ابر ترکیبی",
            description: "مدل قیمت‌گذاری پیاده‌سازی ابر ترکیبی",
            route: "/privatecloud",
            class: "mt-2",
          },
          {
            name: "support-and-migrate",
            title: "پشتیبانی و مهاجرت ابری",
            description:
              "آگاهی از روش محاسبه هزینه سرویس‌های پشتیبانی و مهاجرت ابری",
            route: "/migrate",
            class: "mt-2",
          },
          {
            name: "managed-service",
            title: "سرویس مدیریت شده",
            description: "آگاهی از شیوه قیمت‌گذاری خدمات سرویس‌های مدیریت شده",
            route: "/manageservices",
            class: "mt-2",
          },
        ],
      },
    ],
  },
};

export default {
  services,
  solutions,
  organizationServices,
  cloudStation,
  prices,
  // items: [

  //     {
  //         name: "academy",
  //         title: "آکادمی ابری",
  //         url: 'https://abalon.cloud/blog'
  //     },
  //     {
  //         name: "support",
  //         title: "پشتیبانی",
  //         url: 'https://panel.abalon.cloud/support'
  //     },
  //     {
  //         name: "aboutus",
  //         title: "درباره آبالون",
  //         route: "/aboutus"
  //     },
  //     {
  //         name: "contactUs",
  //         title: "تماس با آبالون",
  //         route: "/contactus"
  //     },
  // ]
};
